import {useEffect, useRef, useState} from 'react'

export const useTruncation = ({text, truncate}) => {
	const ref = useRef()
	const [isTruncated, setIsTruncated] = useState(false)

	useEffect(() => {
		const current = ref?.current
		if (!current || !truncate) return

		const contentWidth = current.scrollWidth
		const boxWidth = current.offsetWidth + 1 // Add 1 to prevent Safari's rounding issues, which trigger tooltips when not necessary.

		setIsTruncated(contentWidth > boxWidth)
	}, [text])

	return {ref, isTruncated}
}
